import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {environment} from "../../../../environments/environment";
import {SchedulerService} from "../../services/sheduler/scheduler.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {Scheduler} from "../../classes/scheduler/scheduler";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DeviceService} from "../../services/device/device.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import * as moment from 'moment';
import {Moment} from 'moment';


@Component({
    selector: 'app-scheduler-spcu',
    templateUrl: './scheduler-spcu.component.html',
    styleUrls: ['./scheduler-spcu.component.css']
})
export class SchedulerSpcuComponent implements OnInit {

    public displayedColumns: string[] = ['start_date', 'end_date', 'status', 'action'];
    public schedulers: MatTableDataSource<any>;
    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;
    public showSpinner: boolean = false;
    public faPlus = faPlus;

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input('deviceId') deviceId: number;


    public schedulerForm: FormGroup = new FormGroup({
        start_date: new FormControl('', [Validators.required]),
        start_date_hour: new FormControl('', [Validators.required]),
        start_date_minute: new FormControl('', [Validators.required]),
        end_date: new FormControl('', [Validators.required]),
        end_date_hour: new FormControl('', [Validators.required]),
        end_date_minute: new FormControl('', [Validators.required]),

    });

    private deviceAssignementId: number = null;

    constructor(private schedulerService: SchedulerService,
                private toastr: ToastrService,
                public activeModal: NgbActiveModal,
                private translate: TranslateService,
                private deviceService: DeviceService) {
    }

    ngOnInit() {
        this.showSpinner = true;
        this.deviceService.getDevice(this.deviceId)
            .subscribe((data: any) => {
                    this.deviceAssignementId = data.project_device_assignement.id;
                    this.showSpinner = false;
                    this.getSchedulerListByDeviceId();
                },
                error2 => {
                    this.showSpinner = false;
                }
            )

    }

    public get start_date() {
        return this.schedulerForm.get('start_date');
    }

    public getErrorMessageStartDate(): string {
        return this.start_date.errors.required ? this.translate.instant('VALUE_FORM_REQUIRED') : '';
    }


    public get end_date() {
        return this.schedulerForm.get('end_date');
    }

    public getErrorMessageEndDate(): string {
        return this.end_date.errors.required ? this.translate.instant('VALUE_FORM_REQUIRED') : '';
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.schedulers.filter = filterValue;
    }

    getSchedulerListByDeviceId() {
        this.showSpinner = true;
        this.schedulerService.getSchedulerByDeviceId(this.deviceId)
            .subscribe(
                (data: any) => {
                    if (data) {
                        this.schedulers = new MatTableDataSource(data);
                        this.schedulers.filter = null;
                        this.schedulers.sort = this.sort;
                        this.schedulers.paginator = this.paginator;
                    }
                    this.showSpinner = false;
                }
                ,
                error2 => {
                    this.showSpinner = false;
                }
            )
    }

    postScheduler() {
        if (this.schedulerForm.valid) {
            this.showSpinner = true;
            let scheduler: Scheduler = new Scheduler;
            scheduler.project_device_assignement = this.deviceAssignementId;
            scheduler.start_date = this.formatDateForScheduler(true);
            scheduler.end_date = this.formatDateForScheduler(false);
            scheduler.status = 'PENDING';
            this.schedulerService.postScheduler(scheduler)
                .subscribe(
                    (data: any) => {

                        this.toastr.success(this.translate.instant('SCHEDULER_ADDED'), this.translate.instant('SUCCESS'));

                        this.showSpinner = false;
                        //    this.schedulerForm.reset();

                        this.getSchedulerListByDeviceId();
                    }
                    ,
                    error2 => {
                        this.showSpinner = false;
                    }
                )
        } else {
            this.toastr.error(this.translate.instant('SCHEDULER_INVALID'), this.translate.instant('ERROR'));
        }

    }

    patchScheduler(schedulerId: number) {
        this.showSpinner = true;
        let scheduler: Scheduler = new Scheduler;

        scheduler.start_date = this.formatDateForScheduler(true);
        scheduler.end_date = this.formatDateForScheduler(false);
        this.schedulerService.patchScheduler(schedulerId, scheduler)
            .subscribe(
                (data: any) => {

                    this.toastr.success('ok', this.translate.instant('SUCCESS'));

                    this.showSpinner = false;
                    this.getSchedulerListByDeviceId()
                }
                ,
                error2 => {
                    this.showSpinner = false;
                }
            )

    }

    deleteScheduler(schedulerId: number) {
        this.showSpinner = true;
        this.schedulerService.deleteScheduler(schedulerId)
            .subscribe(
                (data: any) => {

                    this.toastr.success('ok', this.translate.instant('SUCCESS'));

                    this.showSpinner = false;
                    this.getSchedulerListByDeviceId()
                }
                ,
                error2 => {
                    this.showSpinner = false;
                }
            )

    }

    private formatDateForScheduler(start: boolean = true) {
        let date: Moment = moment();
        let h = '';
        let m = '';
        if (start) {
            date = this.schedulerForm.value.start_date;
            h = this.schedulerForm.value.start_date_hour;
            m = this.schedulerForm.value.start_date_minute;
        } else {
            date = this.schedulerForm.value.end_date;
            h = this.schedulerForm.value.end_date_hour;
            m = this.schedulerForm.value.end_date_minute;

        }
        let dateMonth = (date.month() + 1) < 10 ? '0' + (date.month() + 1) : (date.month() + 1);
        let dateDate = date.date() < 10 ? '0' + date.date() : date.date();
        return date.year() + '-' + dateMonth + '-' + dateDate + 'T' + h + ':' + m + ':00';

    }

}
